import axios, { getData } from 'lib/axios'

export const downloadPaySlip = async (id, data) => {
  return axios.get(`/employee-payslip/${id}`, data).then(getData)
}
